<template>
  <div class="comp-psap-card-site">
    <div
    v-bind:class="{
      blue: infoList.length > 0
    }"
    class="cards-category">
      <comp-icon
      v-bind:icon="'place'"
      v-bind:width="24"></comp-icon>
      <span style="margin-left: 0.2em;">Site</span>
    </div>
    <template v-if="infoList.length > 0">
      <div
      v-on:click="onClickSite" ontouchstart=""
      class="card-container">
        <div
        v-for="(info, index) in infoList"
        v-bind:key="index"
        class="card-info-item">
          <div class="item-title">{{info.title}}</div>
          <div class="item-content">{{info.content ? info.content : 'No data'}}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-info">No information</div>
    </template>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-psap-card-site',
  components: {
    CompIcon
  },
  computed: {
    psapSite: function () {
      return this.$store.getters.psapSite
    }
  },
  data: function () {
    return {
      infoList: []
    }
  },
  watch: {
    psapSite: function () {
      this.updateInfoList()
    }
  },
  created: function () {
    this.updateInfoList()
  },
  methods: {
    updateInfoList: function () {
      if (this.psapSite) {
        this.infoList = []
        this.infoList.push({
          title: 'Customer Account Number',
          content: this.psapSite.customerAccountNumber
        })
        this.infoList.push({
          title: 'Name',
          content: this.psapSite.siteName
        })
        this.infoList.push({
          title: 'Address',
          content: this.psapSite.address
        })
      }
    },
    onClickSite: function () {
      this.$emit('onClickSite', {
        name: this.psapSite.siteName,
        address: this.psapSite.address,
        lat: this.psapSite.lat,
        lng: this.psapSite.lng
      })
    }
  }
}
</script>

<style scoped>
.comp-psap-card-site {
  /* common */
  overflow: hidden;
  /* text */
  text-align: left;
  /* size */
  margin: 3px;
  margin-top: 1em;
  /* shape */
  border-radius: 4px;
}

.comp-psap-card-site .cards-category {
  /* common */
  font-size: 0.8em;
  background-color: #333;
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  padding: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.comp-psap-card-site .cards-category.blue {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
}

.comp-psap-card-site .no-info {
  /* common */
  background-color: #fff;
  color: #aaa;
  /* size */
  height: 4em;
  padding: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.comp-psap-card-site .card-container {
  /* common */
  background-color: #fff;
  color: #000;
  /* mouse */
  cursor: pointer;
  /* size */
  padding: 0.5em 0;
}
.comp-psap-card-site .card-container:hover {
  /* common */
  background-color: hsla(0, 0%, 95%, 1);
}

.comp-psap-card-site .card-container .card-info-item {
  /* size */
  padding: 0.2em 0.5em;
}

.comp-psap-card-site .card-container .card-info-item .item-title {
  /* common */
  font-size: 0.5em;
  /* text */
  text-transform: uppercase;
  /* size */
  padding: 0 5px;
}

.comp-psap-card-site .card-container .card-info-item .item-content {
  /* size */
  padding: 0 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/CompPsapCardSite.vue